<template>
  <div class="container">
    <content-title :nav="nav"></content-title>

    <!-- 学习卡信息 -->
    <el-card class="info-box" v-if="studyCard.id">
      <div class="flex-row" @click="toDetails" style="cursor: pointer">
        <img :src="studyCard.faceUrl" class="face" />
        <div>
          <div class="bold font-size-16">{{ studyCard.title }}</div>
          <div class="margin-top-10">剩余：{{ studyCard.course_num }}节</div>
        </div>
      </div>

      <div class="address-info" v-if="student.name">
        预约人：{{ student.name }}
      </div>

      <div class="address-info">
        服务地址：{{ studyCard.address || "待定" }}
      </div>
    </el-card>

    <!-- 服务教练 -->
    <div class="section-title" v-if="coach.id">服务教练</div>
    <el-card class="coach-box" v-if="coach.id">
      <div class="flex-row coach-info">
        <img :src="coach.head_portrait" class="coach-avatar" />
        <div class="flex-col justify-end coach-detail">
          <div>{{ coach.name }}教练</div>
          <div>{{ coach.teaching_categories }}</div>
        </div>
        <div class="coach-actions">
          <el-button
            type="success"
            size="small"
            @click="openServiceAppoDialog"
            class="appo-service-btn"
          >
            预约服务
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="openCoachChangeDialog"
            class="change-coach-btn"
          >
            修改教练
          </el-button>
        </div>
      </div>
    </el-card>
    <!-- 今日预约 -->
    <div class="section-title">今日预约</div>
    <el-card v-if="todayList.length == 0" class="no-data">
      <div>今日暂无预约，可联系教练或机构安排预约</div>
    </el-card>

    <el-card class="list-box" v-if="todayList.length > 0">
      <div class="appointment-item" v-for="item in todayList" :key="item.id">
        <img
          v-if="item.status == 3"
          src="https://img.curiousmore.com/232919"
          class="handle-pic"
        />
        <div class="appointment-content">
          <div class="font-size-14">
            {{ studyCard.title }}
          </div>
          <div class="time-info">
            服务时间：{{ item.start_time.slice(5, 16) }}~{{
              item.end_time.slice(11, 16)
            }}
          </div>
           <div class="time-info">
            地址：{{ item.remarks || item.offline_address || ''}}
          </div>
          <div class="time-info" v-if="item.completion_time">
            核销时间：{{ item.completion_time }}
          </div>
        </div>
        <el-button
          type="primary"
          size="small"
          @click="openAddressDialog(item)"
          class="edit-address-btn"
        >
          修改地址
        </el-button>
      </div>
    </el-card>

    <!-- 服务信息 -->
    <div class="section-title">服务信息</div>
    <el-card class="list-box" v-if="appointList.length > 0">
      <div class="appointment-item" v-for="item in appointList" :key="item.id">
        <img
          v-if="item.status == 3"
          src="https://img.curiousmore.com/232919"
          class="handle-pic"
        />
        <div class="appointment-content">
          <div class="font-size-14">
            {{ studyCard.title }}
          </div>
          <div class="time-info">
            服务时间：{{ item.start_time.slice(5, 16) }}~{{
              item.end_time.slice(11, 16)
            }}
          </div>
          <div class="time-info">
            地址：{{ item.remarks || item.offline_address || ''}}
          </div>
          <div class="time-info" v-if="item.completion_time">
            核销时间：{{ item.completion_time }}
          </div>
        </div>
        <el-button
          type="primary"
          size="small"
          @click="openAddressDialog(item)"
          class="edit-address-btn"
          v-if="item.status == 2"
        >
          修改地址
        </el-button>
      </div>
    </el-card>

    <el-card v-if="appointList.length == 0" class="no-data">
      <div>暂无预约，可联系教练或机构安排预约</div>
    </el-card>


    <!-- 修改教练弹窗 -->
    <el-dialog
      title="修改上课教练"
      :visible.sync="coachDialogVisible"
      width="600px"
    >
      <el-form label-width="100px">
        <el-form-item label="当前教练">
          <div class="current-coach-info">
            <img :src="coach.head_portrait" class="small-avatar" />
            <span>{{ coach.name }}教练</span>
          </div>
        </el-form-item>
        <el-form-item label="选择新教练" required>
          <coach-select
            :coachid.sync="newCoachId"
            placeholder="请输入教练姓名或电话搜索"
            @change="handleCoachSelect"
          ></coach-select>
        </el-form-item>
        <el-form-item label="新教练信息" v-if="selectedNewCoach">
          <div class="new-coach-info">
            <img :src="selectedNewCoach.head_portrait" class="small-avatar" />
            <div>
              <div>{{ selectedNewCoach.real_name }}教练</div>
              <div class="coach-city">{{ selectedNewCoach.city }}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="coachDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitCoachChange"
          :disabled="!newCoachId"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改地址弹窗 -->
    <el-dialog
      title="修改预约地址"
      :visible.sync="addressEditDialogVisible"
      width="600px"
    >
      <el-form :model="addressForm" :rules="addressRules" ref="addressForm" label-width="100px">
        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="addressForm.remarks"
            type="textarea"
            :rows="3"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="longitude">
          <el-input
            v-model="addressForm.longitude"
            placeholder="请输入经度（如：116.4074）"
            
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="latitude">
          <el-input
            v-model="addressForm.latitude"
            placeholder="请输入纬度（如：39.9042）"
            
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addressEditDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitAddressEdit"
          :loading="addressLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 预约服务弹窗 -->
    <el-dialog
      title="预约服务"
      :visible.sync="serviceAppoDialogVisible"
      width="600px"
    >
      <el-form :model="serviceAppoForm" :rules="serviceAppoRules" ref="serviceAppoForm" label-width="120px">
        <el-form-item label="预约日期" prop="appo_date">
          <el-date-picker
            v-model="serviceAppoForm.appo_date"
            type="date"
            placeholder="选择预约日期"
            :picker-options="datePickerOptions"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-time-select
            v-model="serviceAppoForm.start_time"
            :picker-options="{
              start: '08:00',
              step: '01:00',
              end: '22:00'
            }"
            placeholder="选择开始时间（整点）"
            @change="handleStartTimeChange"
          ></el-time-select>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-time-select
            v-model="serviceAppoForm.end_time"
            :picker-options="{
              start: '08:00',
              step: '01:00',
              end: '22:00',
              minTime: serviceAppoForm.start_time
            }"
            placeholder="选择结束时间（整点）"
            @change="handleEndTimeChange"
          ></el-time-select>
        </el-form-item>
        <el-form-item label="预约小时数">
          <el-input-number
            v-model="serviceAppoForm.num"
            :min="1"
            :max="24"
            :disabled="true"
          ></el-input-number>
          <span class="time-tip">（根据开始和结束时间自动计算）</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="serviceAppoDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitServiceAppo"
          :loading="serviceAppoLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coachSelect from "@/components/select/coachSelect.vue";
import searchAddr from "@/components/searchAddr.vue";

export default {
  name: "CardStudyCard",
  components: {
    coachSelect,
    searchAddr,
  },
  data() {
    return {
      nav: {
        firstNav: "学习卡管理",
        secondNav: "学习卡详情",
      },
      id: "",
      studyCard: {},
      student: {},
      appointList: [],
      todayList: [],
      coach: {},
      addressDialogVisible: false,
      coachDialogVisible: false,
      newCoachId: "",
      selectedNewCoach: null,
      addressEditDialogVisible: false,
      currentAppointment: null,
      addressForm: {
        address: "",
        longitude: "",
        latitude: "",
      },
      addressRules: {
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
      },
      addressLoading: false,
      serviceAppoDialogVisible: false,
      serviceAppoForm: {
        appo_date: "",
        start_time: "",
        end_time: "",
        num: 1,
      },
      serviceAppoRules: {
        appo_date: [
          { required: true, message: "请选择预约日期", trigger: "change" }
        ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "change" }
        ],
      },
      serviceAppoLoading: false,
      // 日期选择器配置：只能选择今天及以后的日期
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 禁用今天之前的日期
        }
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getData();
      this.getCourse();
    }
  },
  methods: {
    submitAddress() {
      if (this.studyCard.address == this.address.address) {
        this.studyCard.editAddress = false;
        this.$message.success("修改成功");
        this.addressDialogVisible = false;
        return;
      }
      this.$http
        .request({
          url: "/user/userStudyCard/userUpdateAddress",
          data: {
            id: this.id,
            address_id: this.address.id,
          },
          method: "post",
        })
        .then((res) => {
          this.studyCard.editAddress = false;
          this.studyCard.address = this.address.address;
          this.clearAddress();
          this.$message.success("修改成功");
          this.addressDialogVisible = false;
        })
        .catch(() => {
          this.$message.error("修改失败");
        });
    },
    openAddressPop() {
      this.addressDialogVisible = true;
    },
    clearAddress() {
      this.$store.commit("setAddress", {});
    },
    toChangeAddress() {
      // PC端可以打开一个新窗口或使用弹窗选择地址
      this.$router.push({
        path: "/address/changeAddress",
        query: { from: "studyCard" },
      });
    },
    toCoachDetails() {
      this.$router.push({
        path: "/coach/details",
        query: { id: this.coach.id },
      });
    },
    toDetails() {
      if (this.studyCard.type == "need") {
        this.$router.push({
          path: "/coach/needCourse/needDetails",
          query: { id: this.studyCard.studycard_id },
        });
      } else if (this.studyCard.type == "venue") {
        this.$router.push({
          path: "/work/venue/serviceDetails",
          query: { id: this.studyCard.studycard_id },
        });
      } else if (this.studyCard.type == "coach_service") {
        this.$router.push({
          path: "/club/coachService/serviceDetails",
          query: { id: this.studyCard.studycard_id },
        });
      } else {
        this.$router.push({
          path: "/work/classChannel/classChannel",
          query: { id: this.studyCard.studycard_id },
        });
      }
    },
    // 服务信息
    getCourse() {
      this.$get("/user/userAppointment/queryListPage", {
        study_card_id: this.id,
      })
        .then((res) => {
          let list = res.data.data;
          let today = new Date().Format("yyyy-MM-dd");
          let today_course = [];
          let other_course = [];
          list.forEach((item) => {
            if (today == item.start_time.split(" ")[0]) {
              today_course.push(item);
            } else {
              other_course.push(item);
            }
          });
          this.appointList = other_course;
          this.todayList = today_course.sort((a, b) => {
            return a.id - b.id;
          });
        })
        .catch(() => {
          this.$message.error("获取预约列表失败");
        });
    },
    // 学习卡数据
    getData() {
      this.$get("/user/userStudyCard/findById", {
        id: this.id,
      })
        .then((res) => {
          this.studyCard = res.data.data;

          if (this.studyCard.map.need) {
            let need = this.studyCard.map.need || {};
            if (!this.studyCard.address) {
              this.studyCard.latitude = need.latitude;
              this.studyCard.longitude = need.longitude;
              this.studyCard.address = need.address;
            }
            if (need.service_type == 2) {
              this.studyCard.editAddress = true;
            }
            this.studyCard.faceUrl = need.face_url;
          } else {
            let course = this.studyCard.map.course || {};
            if (!this.studyCard.address) {
              this.studyCard.latitude = course.latitude;
              this.studyCard.longitude = course.longitude;
              this.studyCard.address = course.venues_addr;
            }
            if (course.teach_type == 2) {
              this.studyCard.editAddress = true;
            }
            this.studyCard.faceUrl = course.face_url;
          }

          this.student = this.studyCard.map.student || {};
          this.coach = this.studyCard.map.coach || {};
        })
        .catch(() => {
          this.$message.error("获取学习卡信息失败");
        });
    },
    // 打开修改教练弹窗
    openCoachChangeDialog() {
      this.newCoachId = "";
      this.selectedNewCoach = null;
      this.coachDialogVisible = true;
    },
    // 处理教练选择
    handleCoachSelect(coach) {
      this.selectedNewCoach = coach;
    },
    // 提交修改教练
    submitCoachChange() {
      if (!this.newCoachId) {
        this.$message.warning("请选择新教练");
        return;
      }

      if (this.newCoachId == this.coach.id) {
        this.$message.warning("新教练与当前教练相同");
        return;
      }

      this.$confirm(
        `确认将教练修改为：${this.selectedNewCoach.real_name}？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$post("/user/userStudyCard/updateCoach", {
            id: this.id,
            coach_id: this.newCoachId,
          })
            .then((res) => {
              this.$message.success("修改教练成功");
              this.coachDialogVisible = false;
              // 重新获取学习卡数据
              this.getData();
            })
            .catch(() => {
              this.$message.error("修改教练失败");
            });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    // 打开地址修改弹窗
    openAddressDialog(item) {
      this.currentAppointment = item;
      this.addressForm = {
        remarks: item.remarks || item.offline_address || "",
        longitude: item.longitude || "",
        latitude: item.latitude || "",
      };
      this.addressEditDialogVisible = true;
    },
    // 提交地址修改
    submitAddressEdit() {
      this.$refs.addressForm.validate((valid) => {
        if (!valid) {
          return false;
        }

        if (!this.currentAppointment) {
          this.$message.error("请选择要修改的预约");
          return;
        }

        this.addressLoading = true;
        this.$post("/user/userAppointment/update", {
          id: this.currentAppointment.id,
          remarks: this.addressForm.remarks,
          longitude: this.addressForm.longitude,
          latitude: this.addressForm.latitude,
        })
          .then(() => {
            this.$message.success("修改地址成功");
            this.addressEditDialogVisible = false;
            // 刷新预约列表
            this.getCourse();
          })
          .catch(() => {
            this.$message.error("修改地址失败");
          })
          .finally(() => {
            this.addressLoading = false;
          });
      });
    },
    // 打开预约服务弹窗
    openServiceAppoDialog() {
      // 默认选择今天
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      
      this.serviceAppoForm = {
        appo_date: `${year}-${month}-${day}`,
        start_time: "",
        end_time: "",
        num: 1,
      };
      this.serviceAppoDialogVisible = true;
    },
    // 处理开始时间变化
    handleStartTimeChange() {
      this.calculateHours();
    },
    // 处理结束时间变化
    handleEndTimeChange() {
      this.calculateHours();
    },
    // 计算预约小时数
    calculateHours() {
      if (this.serviceAppoForm.start_time && this.serviceAppoForm.end_time) {
        const start = new Date(`2000-01-01 ${this.serviceAppoForm.start_time}`);
        const end = new Date(`2000-01-01 ${this.serviceAppoForm.end_time}`);
        const diff = (end - start) / (1000 * 60 * 60); // 转换为小时
        this.serviceAppoForm.num = diff > 0 ? diff : 1;
      }
    },
    // 提交预约服务
    submitServiceAppo() {
      this.$refs.serviceAppoForm.validate((valid) => {
        if (!valid) {
          return false;
        }

        if (!this.coach.id) {
          this.$message.warning("当前没有服务教练");
          return;
        }

        this.serviceAppoLoading = true;
        
        // 构造完整的日期时间
        const startDateTime = `${this.serviceAppoForm.appo_date} ${this.serviceAppoForm.start_time}:00`;
        const endDateTime = `${this.serviceAppoForm.appo_date} ${this.serviceAppoForm.end_time}:00`;

        this.$post("/user/userStudyCard/serviceAppo", {
          study_card_id: this.id,
          start_time: startDateTime,
          end_time: endDateTime,
          coach_id: this.coach.id,
          num: this.serviceAppoForm.num,
        })
          .then(() => {
            this.$message.success("预约服务成功");
            this.serviceAppoDialogVisible = false;
            // 刷新预约列表
            this.getCourse();
          })
          .catch(() => {
            this.$message.error("预约服务失败");
          })
          .finally(() => {
            this.serviceAppoLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.info-box {
  margin-bottom: 20px;

  .face {
    width: 100px;
    height: 100px;
    margin-right: 15px;
    border-radius: 8px;
    object-fit: cover;
  }

  .address-info {
    margin-top: 10px;
    font-size: 14px;
    color: #606266;
  }

  .update-btn {
    margin-top: 15px;
  }

  .address-wrap {
    padding: 10px 15px;
    background-color: #f5f7fa;
    font-size: 14px;
    margin-top: 10px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: #e4e7ed;
    }
  }

  .submit-btn {
    margin-top: 15px;
  }
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0 10px 0;
  padding-left: 10px;
  color: #303133;

  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #409eff;
    margin-right: 8px;
    vertical-align: middle;
  }
}

.coach-box {
  .coach-info {
    position: relative;
  }

  .coach-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 15px;
    object-fit: cover;
  }

  .coach-detail {
    flex: 1;
  }

  .coach-actions {
    display: flex;
    gap: 10px;
  }

  .appo-service-btn {
    margin-left: auto;
  }

  .change-coach-btn {
    // 移除之前的 margin-left: auto
  }
}

.list-box {
  margin-top: 10px;

  .appointment-item {
    padding: 15px 0;
    border-bottom: 1px solid #ebeef5;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    &:last-child {
      border-bottom: none;
    }

    .appointment-content {
      flex: 1;
      padding-right: 100px;
    }

    .handle-pic {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 80px;
      height: 80px;
    }

    .edit-address-btn {
      margin-left: 15px;
      flex-shrink: 0;
    }
  }
}

.time-info {
  color: #909399;
  font-size: 14px;
  margin-top: 8px;
}

.no-data {
  text-align: center;
  font-size: 14px;
  color: #909399;
  padding: 30px;
  margin-top: 10px;
}

.flex-row {
  display: flex;
  align-items: center;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-end {
  justify-content: flex-end;
}

.bold {
  font-weight: bold;
}

.font-size-16 {
  font-size: 16px;
}

.font-size-14 {
  font-size: 14px;
}

.margin-top-10 {
  margin-top: 10px;
}

.current-coach-info,
.new-coach-info {
  display: flex;
  align-items: center;

  .small-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
}

.new-coach-info {
  .coach-city {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }
}

.time-tip {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}
</style>
